/**
 * npm run dev 入口的主文件
 * @author libaoxu@gaosiedu.com
 */
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VueResource from "vue-resource";

import Directives from "directives/index.js";
import Toast from "service/comp/toast";
import PageUp from "components/PageUp";
import VueLazyload from "vue-lazyload";
import Tracker from "common/modules/tracker";
import packageInfo from '../../../package.json'
import DataTrack from "common/modules/tracker/dataTrack.json";
import AliTracking from '@aixuexi/ali-tracking/dist/bundle.es.js'
import * as Sentry from "@sentry/vue";

import S from "service";
import NAPI from "nadaptor";
import cookies from "utils/cookies";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

import { common as $common } from "utils";
import SRC_CONFIG from "src/config";

import utils from "./utils";
import VueProtoMix from "./VueProtoMix";
import actions from "./actions";
import enRouter from "./enRouter";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
// 基础样式
import "commonStyleLess/base.less";

let router;
let store;
// 如果是生产环境, 有些开发人员预留的页面,不能展示, 跳转到首页
if (__prodHide__ && process.env.NODE_ENV === "production") {
  console.error("首次加载循环跳转");
  location.href = "//www.aixuexi.com";
}

// 设置为true, 开启浏览器调试
Vue.config.devtools = true;

// webpack-base-config 中变为 externals, 已经变为全局
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuex);

Vue.use(VueLazyload);
Vue.prototype.$track = new AliTracking(DataTrack);

Vue.use(VueAwesomeSwiper /* { default global options } */);

let previewOptions = {
  fullscreenEl: false,// 显示右上全屏按钮
  zoomEl: true, // 显示放大缩小按钮
  tapToClose: false, // 点击滑动区域关闭图库
  clickToCloseNonZoomable: false // 点击图片关闭图库
}
Vue.use(preview, previewOptions)

Directives.init(Vue);

VueProtoMix(Vue);

/**
 * LOGIN_PAGE 登录链接
 * @param {String}
 */
const LOGOUT_PAGE = SRC_CONFIG.LOGOUT_PAGE;

const ERR_MSG = "用户登录信息获取失败";

const { noop, getInstanceByOptions, getFuncFalseResult } = utils;

const toast = new Toast();

/**
 * 路由默认配置
 */
const RouteConfig = {
  mode: "hash",
  base: __dirname,
};

const DEFAULT_OPTS = {
  apis: {},
  RouteConfig: null,
  store: null,
  beforeInstance: noop,
  afterInstance: noop,
};

actions.loginPromise.then(
  function (data) {
    NAPI.user.set(data);
    Sentry.setUser({
      ...data,
      id: data.userId,
      username: data.username,
    });
    NAPI.listener.trigger(window, "login.header", NAPI.user.get(), "memory");
    Vue.prototype.$track.initBaseInfo({
      system: '爱学习web端',
      'system_version': packageInfo.version,
      institution: data.insId,
      'user_id': data.userId,
    }, {insName: data.insName, roles: data.roles}); // 初始化埋点
  },
  e => {
    let token = cookies.getItem("token") == "null" ? "" : cookies.getItem("token");
    // 未登录时通过token判断用户是【通过域名】直接访问(直接跳转login页)，还是被互踢了(先提示，然后跳登录页)
    if (!token) {
      let loginBackUrl = window.location.href;
      window.location.href =
        "//www.aixuexi.com/logout?loginBackUrl=" + encodeURIComponent(loginBackUrl);
      return;
    }
    const duration = 5000;
    // logininfo 不在request封装里面处理从定向，而是在这里处理 因为 loginInfo接口只要报错就要返回首页
    toast.show({
      message: e,
      duration,
    });
    SRC_CONFIG.LOGOUT_PAGE &&
      setTimeout(() => {
        location.href = SRC_CONFIG.LOGOUT_PAGE + `?loginBackUrl=${location.href}`;
        return toast.destroy();
      }, duration);
  }
);

/**
 * @param {Object} App
 */
export default (App, Prepares, Opts) => {
  Opts = Object.assign(DEFAULT_OPTS, Opts);

  if (Prepares != null && typeof Prepares === "object") {
    if (
      getFuncFalseResult({
        func: Prepares.setLocation,
      })
    )
      return false;
  }

  return actions.loginPromise.then(
    data => {
      if (
        getFuncFalseResult({
          func: Opts.beforeInstance,
          args: [data],
        })
      )
        return false;

      S.extend(Opts.apis);

      // webfunny监控埋点，添加用户标识
      const userId = NAPI.user.get().userId || "";
      window.localStorage.wmUserInfo = JSON.stringify({
        userId: userId,
        projectVersion: "1.0.1",
      });

      // 3. 创建 router 实例，然后传 `routes` 配置
      // 你还可以传别的配置参数, 不过先这么简单着吧。
      // 3.1 可能直接传过来就是 VueRouter实例情况, 直接赋值
      // 3.2 值尽量不要为 undefined 或 false 为 null更好
      router = getInstanceByOptions(Opts.RouteConfig, VueRouter, RouteConfig);
      store = getInstanceByOptions(Opts.store, Vuex.Store);

      // vue 实例
      window.__vm__ = new Vue({
        el: "#app",
        components: {
          App,
          PageUp,
          Tracker,
          VueLazyload,
        },
        store,
        router,
        render(h) {
          // render 支持大写, 但是vue-devtool 对小写和中杠比较友好
          return (
            <div>
              <app> </app> <tracker> </tracker>{" "}
            </div>
          );
        },
      });

      Opts.afterInstance(data);

      /**
       * 引入项目公共头部
       */
      let Legend = null;
      window.Legend;

      let legend = null;
      new Promise((resolve) => {
        window.loadLegendMinJs(() => {
          Legend = window.Legend;
          legend = new Legend(
            Object.assign(SRC_CONFIG.LEGEND_CONFIG, {
              globalBar: {
                isShow: __globalBarHide__ ? false : true,
              },
            })
          );
          resolve()
        })
      }).then(res => {
        __checkLogin__ && legend.trigger("start");
      })
      
      enRouter.init(__vm__, router, store, Opts);

      return Promise.resolve({
        args: [data],
        router,
        vm: window.__vm__,
      });
    },
    e => {
      if (__redirect__) {
        typeof __redirect__ === "function" ? __redirect__() : (location.href = __redirect__);
        return;
      }

      // if (LOGOUT_PAGE) {
      //   location.href = LOGOUT_PAGE+`?loginBackUrl=${location.href}`
      //   toast.destroy()
      // }

      // toast.show(e || ERR_MSG)
    }
  );
};
